const isHostMatch = (hostname, domain) => hostname === domain || hostname.endsWith('.' + domain);

export const getEnv = () => {
  const hostname = new URL(globalThis.location.origin).hostname;
  switch (true) {
    case isHostMatch(hostname, 'one.cube.toyota.com'):
      return 'prod';
    case isHostMatch(hostname, 'one.cubeuat.toyota.com'):
      return 'uat';
    case isHostMatch(hostname, 'one.cubesit.toyota.com'):
      return 'sit';
    case isHostMatch(hostname, 'one.cubesit2.toyota.com'):
      return 'sit2';
    case isHostMatch(hostname, 'one.cubeqa.toyota.com'):
      return 'qa';
    case isHostMatch(hostname, 'one.cubeqa1.toyota.com'):
      return 'qa1';
    case isHostMatch(hostname, 'one.cubeqa2.toyota.com'):
      return 'qa2';
    case isHostMatch(hostname, 'one.cubedev2.toyota.com'):
      return 'dev2';
    case isHostMatch(hostname, 'one.cubedev.toyota.com'):
    case hostname === 'localhost':
    default:
      return 'dev';
  }
};

export const getBaseURL = () =>
  ({
    dev: 'one.cubedev.toyota.com',
    dev2: 'one.cubedev2.toyota.com',
    qa: 'one.cubeqa.toyota.com',
    qa1: 'one.cubeqa1.toyota.com',
    qa2: 'one.cubeqa2.toyota.com',
    uat: 'one.cubeuat.toyota.com',
    sit: 'one.cubesit.toyota.com',
    sit2: 'one.cubesit2.toyota.com',
    prod: 'one.cube.toyota.com',
  }[getEnv()]);
